module.exports = __webpack_public_path__ + "static/img/fourth2.838c14f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/selection/fourth2.png
// module id = PLt9
// module chunks = 25